import { render, staticRenderFns } from "./RoomMatches.vue?vue&type=template&id=1babe1e4&scoped=true"
import script from "./RoomMatches.vue?vue&type=script&lang=js"
export * from "./RoomMatches.vue?vue&type=script&lang=js"
import style0 from "./RoomMatches.vue?vue&type=style&index=0&id=1babe1e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babe1e4",
  null
  
)

export default component.exports